import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Accordion from '@zenbusiness/zui/Accordion';
import AccordionDetails from '@zenbusiness/zui/AccordionDetails';
import AccordionSummary from '@zenbusiness/zui/AccordionSummary';
import Box from '@zenbusiness/zui/Box';

import * as Styled from './FaqItem.styles';

const messageFormatValues = {
  b: (chunks) => <Box component="b">{chunks}</Box>,
  ul: (chunks) => <Styled.FaqList>{chunks}</Styled.FaqList>,
  li: (chunks) => <Box component="li">{chunks}</Box>
};

function FaqItem({ item: { question, answer } }) {
  return (
    <Accordion gap={2}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ width: 24, height: 24 }} />}
      >
        <FormattedMessage id={question} />
      </AccordionSummary>
      <AccordionDetails>
        <FormattedMessage
          id={answer}
          values={messageFormatValues}
        />
      </AccordionDetails>
    </Accordion>
  );
}

FaqItem.propTypes = {
  item: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
  }).isRequired
};
export default FaqItem;
